import React, { useState, useD } from "react";
import { SliderPanel } from "..";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Button, Form, InputGroup } from "react-bootstrap";
import SearchBar from "../../containers/Mapper/LoadDefHomeContainer/SearchBar";
import { Row } from "react-bootstrap";
import AddToolTip from "../AddToolTip/AddToolTip";

const PlanSliderPanelPopUp = (props) => {
  const {
    isSliderOpen,
    savedPlans,
    setSliderOpen,
    setSearchSavedPlans,
    savedPlansFilter,
    header,
    isMapper,
    status,
  } = props;

  const onClose = () => {
    setSearchSavedPlans("");
    setSliderOpen(false);
  };

  return (
    <div>
      <SliderPanel
        isOpen={isSliderOpen}
        size="35"
        showCancel={false}
        showCancelButton={true}
        isMapper={isMapper}
        onClose={onClose}
        showHeader={true}
        header={header}
        headerClass="plan-group-plan-add b-15"
      >
        <div className="plan-count-sub-heading added-plans-style">
          {savedPlansFilter.length} Plans
        </div>
        <div className="width-92">
          <Form>
            <InputGroup>
              <InputGroup.Prepend>
                <div className="search-icon-postion">
                  <i class="fal fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>
              <SearchBar
                size="xs"
                type="search"
                className="plan-search-box pad-left-search"
                placeholder="Search by Plan Name & ID"
                onChange={(e) => setSearchSavedPlans(e.target.value)}
              />
            </InputGroup>
          </Form>
        </div>
        {savedPlansFilter.length == 0 && (
          <div className="p-2 mt-5 fw-600">No records found</div>
        )}
        <div
          className="Add-plan-basic-tiles width-92"
          style={{ paddingLeft: "15px" }}
        >
          {savedPlansFilter?.map((data, index) => {
            const name = data.name ?? data.planName;
            return (
              <Row>
                <div className="tile m-15" style={{ width: "95%" }}>
                  {data.planStatus === 0 ? (
                    <div className="tile-line orange"></div>
                  ) : data.planStatus === 1 ? (
                    <div className="tile-line blue"></div>
                  ) : data.planStatus === 2 ? (
                    <div className="tile-line darkgreen"></div>
                  ) : data.planStatus === 3 ? (
                    <div className="tile-line green"></div>
                  ) : data.planStatus === 4 ? (
                    <div className="tile-line gray"></div>
                  ) : data.planStatus === 5 ? (
                    <div className="tile-line red"></div>
                  ) : (
                    <div className="tile-line green"></div>
                  )}

                  <div className="tile-text pad-left-15">
                    <div className="tile-title w-269 m-17">
                      {name?.length > 10 ? (
                        <AddToolTip name={name}>
                          {(name || "").slice(0, 10)}...
                        </AddToolTip>
                      ) : (
                        name
                      )}
                    </div>
                    <div className="tile-number m-17">
                      {data.rkPlanNumber?.length > 10 ? (
                        <AddToolTip name={data.rkPlanNumber}>
                          {(data.rkPlanNumber || "").slice(0, 10)}...
                        </AddToolTip>
                      ) : (
                        data.rkPlanNumber
                      )}

                      {data.planStatus === 0 ? (
                        <span className="tile-state-orange">
                          UnderConstruction
                        </span>
                      ) : data.planStatus === 1 ? (
                        <span className="tile-state-blue">
                          ReadyForApproval
                        </span>
                      ) : data.planStatus === 2 ? (
                        <span className="tile-state-darkgreen">Approved</span>
                      ) : data.planStatus === 3 ? (
                        <span className="tile-state-green">Active</span>
                      ) : data.planStatus === 4 ? (
                        <span className="tile-state-gray">InActive</span>
                      ) : data.planStatus === 5 ? (
                        <span className="tile-state-red">Terminated</span>
                      ) : status === "Active" ? (
                        <span className="tile-state-green">Active</span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Row>
            );
          })}
        </div>
      </SliderPanel>
    </div>
  );
};

export default PlanSliderPanelPopUp;
